import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
    const navigate = useNavigate();

    // Clean up stale body scroll/pointer lock from Radix Dialog
    useEffect(() => {
        document.body.style.pointerEvents = '';
        document.body.style.overflow = '';
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center py-12 px-4">
            <Card className="w-full max-w-md border-amber-200">
                <CardHeader className="text-center">
                    <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
                        <XCircle className="h-8 w-8 text-amber-600" />
                    </div>
                    <CardTitle className="text-2xl text-amber-800">Payment Cancelled</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <p className="text-center text-slate-600">
                        Your payment was cancelled. No charges have been made to your account.
                    </p>
                    
                    <div className="flex flex-col gap-3">
                        <Button onClick={() => navigate('/payment')} className="w-full">
                            Try Again
                        </Button>
                        <Button variant="outline" onClick={() => navigate('/dashboard')} className="w-full">
                            Back to Dashboard
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
